import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import TitleIcon from '@mui/icons-material/Title';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import VerticalAlignBottomIcon from '@mui/icons-material/VerticalAlignBottom';
import DateRangeIcon from '@mui/icons-material/DateRange';
import AddBoxIcon from '@mui/icons-material/AddBox';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import VerticalAlignTopIcon from '@mui/icons-material/VerticalAlignTop';
import BlockIcon from '@mui/icons-material/Block';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import EventIcon from '@mui/icons-material/Event';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import KeyboardTabIcon from '@mui/icons-material/KeyboardTab';
import FindReplaceIcon from '@mui/icons-material/FindReplace';
import ContentCutIcon from '@mui/icons-material/ContentCut';
import CallSplitIcon from '@mui/icons-material/CallSplit';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import NumbersIcon from '@mui/icons-material/Numbers';
import WaterIcon from '@mui/icons-material/Water';
import LooksOneIcon from '@mui/icons-material/LooksOne';
import PinIcon from '@mui/icons-material/Pin';
import PercentIcon from '@mui/icons-material/Percent';
import FlashOnIcon from '@mui/icons-material/FlashOn';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import TextFormatIcon from '@mui/icons-material/TextFormat'; 
import SearchIcon from '@mui/icons-material/Search';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import StraightenIcon from '@mui/icons-material/Straighten';
import FindInPageIcon from '@mui/icons-material/FindInPage';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import FormatIndentDecreaseIcon from '@mui/icons-material/FormatIndentDecrease';
import PaddingIcon from '@mui/icons-material/Padding';
import SpaceBarIcon from '@mui/icons-material/SpaceBar';
import TodayIcon from '@mui/icons-material/Today';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import LayersIcon from '@mui/icons-material/Layers';
import DescriptionIcon from '@mui/icons-material/Description';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { Box, IconButton, Modal, Tooltip } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useSnackbar } from 'notistack';
import React, { memo, useContext, useEffect, useState } from 'react';
import { BsDownload } from 'react-icons/bs';
import { FiMaximize, FiMinimize } from 'react-icons/fi';
import { GrValidate } from 'react-icons/gr';
import { ImProfile } from 'react-icons/im';
import { Handle } from 'reactflow';
import { v4 as uuidv4 } from 'uuid';
import { AWS_CONFIG_TYPE } from '../../BaseUrl';
import {
  downloadFilesOfS3,
  fetchSampleRecordsApi,
  getCSVFileList,
  runEmrForSampleRecordApi,
} from "../../api's/DataProcessorApi";
import ingestionWrite from '../../assets/images/Data_Ingestion.png';
import DatabaseIcon from '../../assets/images/Database.png';
import mySQLServerIcon from '../../assets/images/sql-server.jpg';
import rulesSelectorIcon from '../../assets/images/RulesSelector.png';
import fileUploaderIcon from '../../assets/images/UploadFile.png';
import agenticAiIcon from '../../assets/images/ai-assistant.gif';
import xmdmAgentAiIcon from '../../assets/images/xmdm-agent.gif';
import analysisIcon from '../../assets/images/analysis.png';
import analyticIcon from '../../assets/images/analytics.png';
import ApiIcon from '../../assets/images/api.png';
import readIcon from '../../assets/images/books.png';
import cleansingIcon from '../../assets/images/cleansing.png';
import clusterIcon from '../../assets/images/cluster_icon.png';
import concatIcon from '../../assets/images/concat.png';
import copyDocIcon from '../../assets/images/copyDoc.png';
import cosmosIcon from '../../assets/images/cosmos.png';
import readCsvIcon from '../../assets/images/csv.png';
import AddIcon from '../../assets/images/plus.png';
import deleteIcon from '../../assets/images/remove.png';
import custSegmentationIcon from '../../assets/images/customer-segment.png';
import dataProfilingIcon from '../../assets/images/dataProfiling.png';
import dataQualityIssuesIcon from '../../assets/images/dataQualityIssues.png';
import dataQualityRulesIcon from '../../assets/images/dataQualityRules.png';
import datatypeIcon from '../../assets/images/datatype.png';
import dataValidationIcon from '../../assets/images/datavalidation.png';
import datetimeIcon from '../../assets/images/datetime.png';
import readDelimitedIcon from '../../assets/images/delimited.png';
import dropIcon from '../../assets/images/drop.png';
import fetchSchemaIcon from '../../assets/images/fetchSchema.png';
import filterIcon from '../../assets/images/filter.png';
import flatUnionIcon from '../../assets/images/flatUnion.png';
import fuzzyLogicIcon from '../../assets/images/fuzzy_logic.jpg';
import executeSqlIcon from '../../assets/images/gear.png';
import handleNullIcon from '../../assets/images/handlenull.png';
import imbalancedDataIcon from '../../assets/images/imbalance.png';
import kpiIcon from '../../assets/images/kpi.png';
import labelEncoderIcon from '../../assets/images/label_encoder.png';
import joinIcon from '../../assets/images/link.png';
import llmMapperIcon from '../../assets/images/llmMapper.png';
import emailIcon from '../../assets/images/mail.png';
import mathTransformationIcon from '../../assets/images/math_transformation.png';
import readMdmIcon from '../../assets/images/mdm.png';
import manualMergeIcon from '../../assets/images/merge.png';
import coalesce from '../../assets/images/merger.png';
import oneHotEncoderIcon from '../../assets/images/one_hot_encoder.png';
import openSearchIcon from '../../assets/images/openSearch.png';
import outlierIcon from '../../assets/images/outlier.png';
import pEDataReportIcon from '../../assets/images/pEDataReport.png';
import peInsightsMapperIcon from '../../assets/images/pEInsightsMapper.png';
import pdfDataExtractorIcon from '../../assets/images/pdfDataExtractor.png';
import writeIcon from '../../assets/images/pencil.png';
import plotIcon from '../../assets/images/plot_icon.png';
import predictionIcon from '../../assets/images/prediction.png';
import profilingIcon from '../../assets/images/profiling.png';
import readAuroraDBIcon from '../../assets/images/readAuroraDB.jpg';
import readCsvDataIcon from '../../assets/images/readCsvData.png';
import readDB2Icon from '../../assets/images/readDB2.png';
import readOracleIcon from '../../assets/images/readOracle.png';
import readPostgresIcon from '../../assets/images/readPostgres.png';
import readPublishedDataIcon from '../../assets/images/readPublishedData.png';
import readRealTimeIcon from '../../assets/images/realtime-icon.png';
import resampleIcon from '../../assets/images/resample.png';
import RfmIcon from '../../assets/images/rfm.png';
import ruleGeneratorIcon from '../../assets/images/ruleGenerator.png';
import ruleEngineIcon from '../../assets/images/rule_engine.png';
import scalerIcon from '../../assets/images/scaler.png';
import segmentationIcon from '../../assets/images/segmentation.png';
import selectIcon from '../../assets/images/select.png';
import DuplicateIcon from '../../assets/images/duplicate.png';
import CountIcon from '../../assets/images/count.png';
import SwapIcon from '../../assets/images/swap.png';
import snowFlakeIcon from '../../assets/images/snowFlake.png';
import snowflakeReadIcon from '../../assets/images/snowflake_read.png';
import sortIcon from '../../assets/images/sorting.png';
import readSqlIcon from '../../assets/images/sql.png';
import trainingIcon from '../../assets/images/training.png';
import udfIcon from '../../assets/images/udf1.png';
import dataQualityReportIcon from '../../assets/images/dataQualityReport.png';
import unionIcon from '../../assets/images/union.png';
import visualInsightsIcon from '../../assets/images/visualInsights.png';
import visualizationIcon from '../../assets/images/visualization.png';
import workflowIcon from '../../assets/images/workflow.png';
import writeSFTPIcon from '../../assets/images/writeSFTP.png';
import AbsIcon from '../../assets/images/abs-icon.png';
import { WorkflowContext } from '../../contexts/WorkflowProvider';
import {
  DATA_QUALITY_AGENT,
  DATA_QUALITY_RULES,
  DATA_QUALITY_RULES2,
  FETCH_SCHEMA,
  LLM_DQ_RULES,
  LLM_DQ_RULES_2,
  LLM_MAPPER,
  PE_DATA_REPORT,
  PE_INSIGHTS_MAPPER,
  DEDUPLICATION_AGENT,
  DATA_QUALITY_REPORT,
} from '../../utils/NodeModalContants';
import HtmlModal from './HtmlModal';
import ResultModal from './ResultModal';

function CustomNode({ data, isConnectable, id }) {
  const { enqueueSnackbar } = useSnackbar();
  const { workflow } = useContext(WorkflowContext);
  const [updated, setUpdated] = useState('unknown');
  const [executionTime, setExecutionTime] = useState(0);
  const [errorDetails, setErrorDetails] = useState(null);
  const [sampleData, setSampleData] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [htmlData, setHtmlData] = useState('');
  const [openResultModal, setOpenResultModal] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [sampleViewHeader, setSampleViewHeader] = useState([]);
  const [sampleViewData, setSampleViewData] = useState([]);

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',

    bgcolor: '#fff',
    border: '1px solid #000',
    borderRadius: '10px',
    boxShadow: 24,
    p: 4,
    overflow: 'scroll',
    height: isFullScreen ? '100%' : '70%',
    width: isFullScreen ? '100%' : '70%',

    '::-webkit-scrollbar': {
      width: '10px',
      height: '10px',
    },

    '::-webkit-scrollbar-track': {
      backgroundColor: '#ddd',
    },

    '::-webkit-scrollbar-thumb': {
      background: '#a4a4a4',
      borderRadius: '25px',
    },
    '::-webkit-scrollbar-thumb:hover': {
      background: '#555',
    },
  };

  const updateNodes = JSON.parse(sessionStorage.getItem('updatedNodes')) || [];
  const nodeStatus = JSON.parse(sessionStorage.getItem('nodeStatus')) || [];

  const [addColumnModalOpen, setAddColumnModalOpen] = useState(false);

  const handleAddColumnModalOpen = () => {
    setAddColumnModalOpen(true);
  };

  const handleAddColumnModalClose = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setAddColumnModalOpen(false);
  };

  const handleFullScreenModal = () => {
    setIsFullScreen(!isFullScreen);
  };

  useEffect(() => {
    nodeStatus?.forEach((el) => {
      const trimmedNodeId = el.node_id.split('__')[0];
      if (trimmedNodeId === id) {
        (el.status === 'Running' || el.status === 'RUNNING') && setUpdated('running');
        (el.status === 'Completed' || el.status === 'COMPLETED') && setUpdated('completed');
        (el.status === 'Failed' || el.status === 'FAILED') && setUpdated('failed');
        setExecutionTime(el.execution_time);
        setErrorDetails(el.error_details);
      }
    });

    return () => {
      setUpdated('unknown');
    };
  }, [nodeStatus]);

  useEffect(() => {
    updateNodes.forEach((el) => {
      if (el === id) {
        setUpdated('updated');
      }
    });

    return () => {
      setUpdated('unknown');
    };
  }, [updateNodes]);

  const getAllNodes = JSON.parse(sessionStorage.getItem('allNodes') || '[]');

  const handleDownloadFile = async () => {
    enqueueSnackbar('File Downloading Started.', {
      variant: 'warning',
      autoHideDuration: 3000,
      anchorOrigin: { vertical: 'top', horizontal: 'right' },
    });
    const sampleCSVLocation = `${workflow.engagement.client.client_name}/${workflow.engagement.engagement_name}/${workflow.workflow_name}/Data_Processor/SampleRecords/${id}/Output/${sampleData.fileName}`;

    const data = {
      file_path: sampleCSVLocation,
      client_id: workflow.engagement.client.client_id,
      aws_config_type: AWS_CONFIG_TYPE,
    };
    try {
      await downloadFilesOfS3(data);
      enqueueSnackbar('File Downloaded.', {
        variant: 'success',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
    } catch (error) {
      console.log(error);
      enqueueSnackbar('Internal Server Error.', {
        variant: 'warning',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
    }
  };

  const fetchSampleView = async (type) => {
    enqueueSnackbar('We are fetching result.', {
      variant: 'warning',
      autoHideDuration: 3000,
      anchorOrigin: { vertical: 'top', horizontal: 'right' },
    });
    setSampleData({});

    // if (type === 'run-emr') {
    //   enqueueSnackbar('EMR is running! Result available in few minutes', {
    //     variant: 'warning',
    //     autoHideDuration: 3000,
    //     anchorOrigin: { vertical: 'top', horizontal: 'right' },
    //   });
    // }
    const getAllDataFromLocalStorage = JSON.parse(sessionStorage.getItem('allNodes'));

    const nodeExist = getAllDataFromLocalStorage.findIndex((el) => el.nodeId === id);

    if (nodeExist === -1) {
      enqueueSnackbar("Data for this node doesn't exist!!", {
        variant: 'error',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
      return;
    }

    // const sourceList = [id];
    // getNodesID(id, sourceList);

    // const nodesData = [];

    // sourceList.forEach((item) => {
    //   const nodes = getAllDataFromLocalStorage.find((el) => el.nodeId === item);
    //   if (nodes) nodesData.push(nodes);
    // });

    // nodesData.sort((a, b) => a.y_axis - b.y_axis);

    // let count = 1;
    // nodesData.forEach((el) => {
    //   el.formField.step_no = count;
    //   count++;
    // });

    // nodesData.sort((a, b) => a.formField.step_no - b.formField.step_no);

    // const formData = convertToRequiredFormat(nodesData, '', '', id);

    // if (formData.steps[formData.steps.length - 1] === null) {
    //   formData.steps.pop();
    // }

    const sampleCSVLocation = `${workflow.engagement.client.client_name}/${workflow.engagement.engagement_name}/${workflow.workflow_name}/Data_Processor/SampleRecords/${id}/Output/`;
    // const sampleCSVLocation = `Delivery/TruckArrival/TruckArrival/Data_Processor/output/20221207135511795/part-00000-d688c11c-827d-4a61-820d-b1621f599930-c000.csv`;

    // const execution_id = `${workflow.engagement.client.client_name}_${workflow.engagement.engagement_name}_${
    //   workflow.workflow_name
    // }_dataProcessor_${new Date().getTime()}`;

    // const sampleJsonLocation = `${workflow.engagement.client.client_name}/${workflow.engagement.engagement_name}/${workflow.workflow_name}/Data_Processor/SampleRecords/${id}/Scripts/${id}.json`;

    const data = {
      client_id: workflow.engagement.client.client_id,
      client_name: workflow.engagement.client.client_name,
      engagement_id: workflow.engagement.engagement_id,
      engagement_name: workflow.engagement.engagement_name,
      workflow_id: workflow.workflow_id,
      workflow_name: workflow.workflow_name,
      csvPath: sampleCSVLocation,
      bucket_name: workflow.engagement.client.bucket_name,
      data_region: workflow.engagement.client.data_region,
      aws_config_type: AWS_CONFIG_TYPE,
    };

    // try {
    //   await createSampleJsonApi(data);
    // } catch (error) {
    //   console.log(error);
    //   enqueueSnackbar('Server error! Something went wrong!', {
    //     variant: 'error',
    //     autoHideDuration: 3000,
    //     anchorOrigin: { vertical: 'top', horizontal: 'right' },
    //   });
    // }

    if (type === 'run-emr') {
      await runEmrForSampleRecordApi(data);
    } else {
      try {
        const response = await fetchSampleRecordsApi(data);

        setSampleData(response.data);
        const headers = [];
        // const headers = [{ field: "id", headerName: "Id", width: 150 }];
        response.data.headers.map((el, i) => {
          headers.push({
            field: el.title,
            headerName: el.dataIndex,
            width: 150,
          });
        });

        setSampleViewHeader(headers);

        const values = [];
        response.data.data.map((el) => {
          values.push({
            id: uuidv4(),
            ...el,
          });
        });
        setSampleViewData(values);

        response.status === 200 && Object.keys(response.data).length !== 0 && handleAddColumnModalOpen();

        if (Object.keys(response.data).length === 0) {
          enqueueSnackbar('Sample view not done! Please run the flow..', {
            variant: 'warning',
            autoHideDuration: 3000,
            anchorOrigin: { vertical: 'top', horizontal: 'right' },
          });
          return;
        }
      } catch (error) {
        console.log(error);
        if (error.response.status === 404) {
          enqueueSnackbar('Sample view not done! Please run the flow..', {
            variant: 'warning',
            autoHideDuration: 3000,
            anchorOrigin: { vertical: 'top', horizontal: 'right' },
          });
        }

        if (error.response.status === 403) {
          enqueueSnackbar('You have only Read Permission !!', {
            variant: 'error',
            autoHideDuration: 3000,
            anchorOrigin: { vertical: 'top', horizontal: 'right' },
          });
        }

        if (error.response.status === 500) {
          enqueueSnackbar(error.response.data || 'Internal Server Error !!', {
            variant: 'error',
            autoHideDuration: 3000,
            anchorOrigin: { vertical: 'top', horizontal: 'right' },
          });
        }
      }
    }
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleCloseResultModal = () => {
    setOpenResultModal(false);
  };

  const handleOpenModal = (e, nodeType, htmlData) => {
    let isPresent = false;
    const getAllNodes = JSON.parse(sessionStorage.getItem('allNodes') || '[]');
    getAllNodes.map((el) => {
      if (el.step_name === nodeType) {
        isPresent = true;
      }
    });

    if (isPresent) {
      setOpenModal(true);
      setHtmlData(htmlData);
    } else {
      enqueueSnackbar(`${nodeType} Not Done`, {
        variant: 'error',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
    }
  };

    const nodeIconMap = {
    abs: <img src={AbsIcon} width="30" alt="abs" style={{ filter: 'contrast(200%)', margin: '10px' }} />,
    lower: <ArrowDownwardIcon style={{ fontSize: 30, color: 'gray', margin: '10px' }} />,
    upper: <TitleIcon style={{ fontSize: 30, color: '#1976d2', margin: '10px' }} />,
    floor: <VerticalAlignBottomIcon style={{ fontSize: 30, color: 'green', margin: '10px' }} />,
    concat_ws: <img src={concatIcon} width="30" alt="concat_ws" style={{ filter: 'contrast(200%)', margin: '10px' }} />,
    current_date: <TodayIcon style={{ fontSize: 30, margin: '10px' }} />,
    current_time: <AccessTimeIcon style={{ fontSize: 30, margin: '10px' }} />,
    coalesce: <LayersIcon style={{ fontSize: 30, margin: '10px' }} />,
    trim: <ContentCutIcon style={{ fontSize: 30, margin: '10px' }} />,
    initcap: <TitleIcon style={{ fontSize: 30, margin: '10px' }} />,
    isnumber: <PinIcon style={{ fontSize: 30, margin: '10px' }} />,
    instr: <SearchIcon style={{ fontSize: 30, margin: '10px' }} />,
    isnull: <HelpOutlineIcon style={{ fontSize: 30, margin: '10px' }} />,
    length: <StraightenIcon style={{ fontSize: 30, margin: '10px' }} />,
    indexof: <FindInPageIcon style={{ fontSize: 30, margin: '10px' }} />,
    ltrim: <FormatIndentDecreaseIcon style={{ fontSize: 30, margin: '10px' }} />,
    lpad: <PaddingIcon style={{ fontSize: 30, margin: '10px' }} />,
    isspaces: <SpaceBarIcon style={{ fontSize: 30, margin: '10px' }} />,
    rpad: <KeyboardTabIcon style={{ fontSize: 30, margin: '10px' }} />,
    replace: <FindReplaceIcon style={{ fontSize: 30, margin: '10px' }} />,
    substr: <ContentCutIcon style={{ fontSize: 30, margin: '10px' }} />,
    split: <CallSplitIcon style={{ fontSize: 30, margin: '10px' }} />,
    regexp_replace: <AutoFixHighIcon style={{ fontSize: 30, margin: '10px' }} />,
    round: <ChangeCircleIcon style={{ fontSize: 30, margin: '10px' }} />,
    regexp_instr: <SearchIcon style={{ fontSize: 30, margin: '10px' }} />,
    to_decimal: <NumbersIcon style={{ fontSize: 30, margin: '10px' }} />,
    to_float: <WaterIcon style={{ fontSize: 30, margin: '10px' }} />,
    to_integer: <LooksOneIcon style={{ fontSize: 30, margin: '10px' }} />,
    to_bigint: <PinIcon style={{ fontSize: 30, margin: '10px' }} />,
    row_number: <FormatListNumberedIcon style={{ fontSize: 30, margin: '10px' }} />,
    mod: <PercentIcon style={{ fontSize: 30, margin: '10px' }} />,
    power: <FlashOnIcon style={{ fontSize: 30, margin: '10px' }} />,
    reverse: <SwapHorizIcon style={{ fontSize: 30, margin: '10px' }} />,
    trunc_dates: <DateRangeIcon style={{ fontSize: 30, margin: '10px' }} />,
    nullif: <BlockIcon style={{ fontSize: 30, margin: '10px' }} />,
    regexp_substr: <TextSnippetIcon style={{ fontSize: 30, margin: '10px' }} />,
    last_day: <EventAvailableIcon style={{ fontSize: 30, margin: '10px' }} />,
    add_to_date: <EventIcon style={{ fontSize: 30, margin: '10px' }} />,
    date_diff: <CompareArrowsIcon style={{ fontSize: 30, margin: '10px' }} />,
    to_date: <CalendarMonthIcon style={{ fontSize: 30, margin: '10px' }} />,
    add_static_value: <AddBoxIcon style={{ fontSize: 30, margin: '10px' }} />,
    rtrim: <ContentCutIcon style={{ fontSize: 30, margin: '10px' }} />,
    to_char: <TextFormatIcon style={{ fontSize: 30, margin: '10px' }} />,
    to_char_numbers: <PinIcon style={{ fontSize: 30, margin: '10px' }} />,
    date_compare: <EventRepeatIcon style={{ fontSize: 30, margin: '10px' }} />,
    is_date: <EventAvailableIcon style={{ fontSize: 30, margin: '10px' }} />,
    trunc_numbers: <VerticalAlignBottomIcon style={{ fontSize: 30, margin: '10px' }} />,
    reg_extract: <FindInPageIcon style={{ fontSize: 30, margin: '10px' }} />,
    reg_match: <CheckCircleOutlineIcon style={{ fontSize: 30, margin: '10px' }} />,
    ceil: <VerticalAlignTopIcon style={{ fontSize: 30, margin: '10px' }} />,
  };

  const handleOpenResultModal = (e, nodeType) => {
    let isPresent = false;
    const getAllNodes = JSON.parse(sessionStorage.getItem('allNodes') || '[]');
    getAllNodes.map((el) => {
      if (el.step_name === nodeType) {
        isPresent = true;
      }
    });

    const path = getAllNodes.find((el) => el.nodeId === id)?.formField?.path;
    const value = path?.substring(path.indexOf('dep-develop/'), path.length).replace('dep-develop/', '');
    const pathPrefix = value?.endsWith('/') ? value : `${value}/prediction`;

    if (isPresent) {
      setOpenResultModal(true);
      getFile(pathPrefix);
    } else {
      enqueueSnackbar(`${nodeType} Not Done`, {
        variant: 'error',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
    }
  };

  const getFile = async (pathPrefix) => {
    const data = {
      prefix: pathPrefix,
      client_id: workflow.engagement.client.client_id,
      aws_config_type: AWS_CONFIG_TYPE,
    };
    try {
      setLoading(true);
      const response = await getCSVFileList(data);
      if (response.status === 200) {
        setFileList(response.data);
      }
    } catch (error) {
      if (error.response?.status === 500) {
        enqueueSnackbar('500 Internal Server Error!', {
          variant: 'error',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
      } else if (error.response?.status === 404) {
        enqueueSnackbar('404 Prediction Result not found!', {
          variant: 'error',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
      }
      setLoading(false);
    }
    setLoading(false);
  };

  const getNodesID = (nodeid, sourceList) => {
    let nodeType;
    JSON.parse(sessionStorage.getItem('node')).forEach((el) => {
      if (nodeid === el.id) {
        nodeType = el.data.initNode;
      }
    });

    if (nodeType === 'read') {
      sourceList.push(nodeid);
      return sourceList;
    }

    const edgesFromLocalStorage = JSON.parse(sessionStorage.getItem('edges'));
    const sourceid = [];

    edgesFromLocalStorage.forEach((el) => {
      if (el.target === nodeid) {
        sourceid.push(el.source);
      }
    });

    sourceid.forEach((el) => {
      sourceList.push(el);
      getNodesID(el, sourceList);
    });
  };

  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          marginTop: '20px',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {data.initNode === 'DataValidation' && (
          <div>
            <Tooltip title="Data Profiling" placement="left">
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  // data.onNodesChange([{ id, type: 'remove' }]);
                  handleOpenModal(e, data.initNode, 'profiling');
                }}
              >
                <ImProfile style={{ fontSize: '20px' }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Validation Result" placement="right">
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  // data.onNodesChange([{ id, type: 'remove' }]);
                  handleOpenModal(e, data.initNode, 'validation');
                }}
              >
                <GrValidate style={{ fontSize: '20px' }} />
              </IconButton>
            </Tooltip>
          </div>
        )}
        {data.initNode === 'Training' && (
          <div>
            <Tooltip title="Train Result" placement="right">
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  // data.onNodesChange([{ id, type: 'remove' }]);
                  handleOpenModal(e, data.initNode, 'training');
                }}
              >
                <ImProfile style={{ fontSize: '20px' }} />
              </IconButton>
            </Tooltip>
          </div>
        )}
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            padding: '10px 20px',
            border: '3px solid ',
            borderRadius: '5px',
            borderColor: `${
              data.initNode === 'FileUploader' ||
              data.initNode === 'DataQualityIssues' ||
              data.initNode === 'DataQualityIssues2' ||
              data.initNode === PE_DATA_REPORT.nodeModalTitle ||
              data.initNode === PE_INSIGHTS_MAPPER.nodeModalTitle ||
              data.initNode === DATA_QUALITY_REPORT.nodeModalTitle ||
              data.initNode === 'Match & Merge'
                ? '#70e000'
                : (updated === 'unknown' && '#ddd') ||
                  (updated === 'updated' && '#7400b8') ||
                  (updated === 'completed' && '#70e000') ||
                  (updated === 'running' && '#fb8500') ||
                  (updated === 'failed' && '#d00000')
            }`,
            alignItems: 'center',
          }}
        >
          <Tooltip
            title={
              <>
                <div style={{ whiteSpace: 'pre-line' }}>{data.label}</div>
                <div style={{ whiteSpace: 'pre-line' }}>
                  {executionTime === 0 ? `` : `Execution Time: ${executionTime} ms`}
                </div>
                <div style={{ whiteSpace: 'pre-line' }}>
                  {errorDetails === '' || errorDetails === null ? `` : `Error: ${errorDetails}`}
                </div>
              </>
            }
            placement="top"
          >
            <div>
              {data.initNode !== 'CopyDoc' && (
                <Handle
                  type="target"
                  position="left"
                  style={{ padding: '7px', backgroundColor: '#aaa' }}
                  onConnect={(params) => console.log('', params)}
                  isConnectable={isConnectable}
                />
              )}
              {data.initNode === 'Read' && (
                <div style={{ textAlign: 'center' }}>
                  <img src={readIcon} width="30" alt="Nagarro" style={{ filter: 'contrast(200%)', margin: '10px' }} />
                </div>
              )}
              {data.initNode === 'ReadCSV' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={readCsvIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                </div>
              )}
              {data.initNode === 'ReadPostgres2' && (
                <div style={{ textAlign: 'center', position: 'relative' }}>
                  <img
                    src={readPostgresIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                  <span
                    style={{
                      position: 'absolute',
                      top: '80%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      color: '#bbb',
                      fontSize: '12px',
                      fontWeight: 'bold',
                    }}
                  >
                    read
                  </span>
                </div>
              )}
              {data.initNode === 'ReadSQLServer' && (
                <div style={{ textAlign: 'center', position: 'relative' }}>
                  <img src={mySQLServerIcon} width="50" alt="Nagarro" style={{ margin: '5px 0' }} />
                  <span
                    style={{
                      position: 'absolute',
                      top: '90%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      color: '#bbb',
                      fontSize: '12px',
                      fontWeight: 'bold',
                    }}
                  >
                    read
                  </span>
                </div>
              )}
              {data.initNode === 'ReadSnowflake2' && (
                <div style={{ textAlign: 'center', position: 'relative' }}>
                  <img
                    src={snowflakeReadIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                  <span
                    style={{
                      position: 'absolute',
                      top: '84%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      color: '#bbb',
                      fontSize: '12px',
                      fontWeight: 'bold',
                    }}
                  >
                    read
                  </span>
                </div>
              )}
              {data.initNode === 'ReadOracleDB' && (
                <div style={{ textAlign: 'center', position: 'relative' }}>
                  <img
                    src={readOracleIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                  <span
                    style={{
                      position: 'absolute',
                      top: '80%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      color: '#bbb',
                      fontSize: '12px',
                      fontWeight: 'bold',
                    }}
                  >
                    read
                  </span>
                </div>
              )}
              {data.initNode === 'ReadCSVAws' && (
                <div style={{ textAlign: 'center', position: 'relative' }}>
                  <img
                    src={readCsvIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                  <span
                    style={{
                      position: 'absolute',
                      top: '86%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      color: '#bbb',
                      fontSize: '12px',
                      fontWeight: 'bold',
                    }}
                  >
                    aws
                  </span>
                </div>
              )}
              {data.initNode === 'ReadCSVAzure' && (
                <div style={{ textAlign: 'center', position: 'relative' }}>
                  <img
                    src={readCsvIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                  <span
                    style={{
                      position: 'absolute',
                      top: '86%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      color: '#bbb',
                      fontSize: '12px',
                      fontWeight: 'bold',
                    }}
                  >
                    azure
                  </span>
                </div>
              )}
              {data.initNode === 'AddColumn' && (
                <div style={{ textAlign: 'center' }}>
                  <img src={AddIcon} width="30" alt="Nagarro" style={{ filter: 'contrast(200%)', margin: '10px' }} />
                </div>
              )}
              {data.initNode === 'DeleteColumn' && (
                <div style={{ textAlign: 'center' }}>
                  <img src={deleteIcon} width="30" alt="Nagarro" style={{ filter: 'contrast(200%)', margin: '10px' }} />
                </div>
              )}
              {data.initNode === 'SwapColumn' && (
                <div style={{ textAlign: 'center' }}>
                  <img src={SwapIcon} width="30" alt="Nagarro" style={{ filter: 'contrast(200%)', margin: '10px' }} />
                </div>
              )}
              {data.initNode === 'CountBlock' && (
                <div style={{ textAlign: 'center' }}>
                  <img src={CountIcon} width="30" alt="Nagarro" style={{ filter: 'contrast(200%)', margin: '10px' }} />
                </div>
              )}
              {data.initNode === 'DuplicacyCheck' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={DuplicateIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                </div>
              )}
              {data.initNode === 'ReadCSVData' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={readCsvDataIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                </div>
              )}
              {data.initNode === 'Visualization' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={visualizationIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                </div>
              )}
              {data.initNode === `${DATA_QUALITY_RULES.nodeModalTitle}` && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={dataQualityRulesIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                </div>
              )}{' '}
              {data.initNode === `${DATA_QUALITY_RULES2.nodeModalTitle}` && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={dataQualityRulesIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                </div>
              )}
              {data.initNode === `${DATA_QUALITY_AGENT.nodeModalTitle}` && (
                <div style={{ textAlign: 'center', position: 'relative' }}>
                  <img
                    src={agenticAiIcon}
                    width="40"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '5px' }}
                  />
                </div>
              )}
              {data.initNode === `${DEDUPLICATION_AGENT.nodeModalTitle}` && (
                <div style={{ textAlign: 'center', position: 'relative' }}>
                  <img
                    src={xmdmAgentAiIcon}
                    width="40"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '5px' }}
                  />
                </div>
              )}
              {data.initNode === `${LLM_DQ_RULES.nodeModalTitle}` && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={dataQualityRulesIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                </div>
              )}
              {data.initNode === `${LLM_DQ_RULES_2.nodeModalTitle}` && (
                <div style={{ textAlign: 'center', position: 'relative' }}>
                  <img
                    src={dataQualityRulesIcon}
                    width="40"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '5px' }}
                  />
                  <AutoAwesomeIcon
                    sx={{
                      position: 'absolute',
                      top: '83%',
                      left: '50%',
                      transform: 'translate(86%, -46%)',
                      fontSize: '18px',
                      fontWeight: 'bold',
                      fill: 'url(#greenBlueGradient)',
                    }}
                  />
                  <svg width="0" height="0">
                    <defs>
                      <linearGradient id="greenBlueGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#00f5a0" /> {/* Start with green */}
                        <stop offset="15%" stopColor="#00f5a0" /> {/* Keep green till 30% */}
                        <stop offset="100%" stopColor="#007cf0" /> {/* Dominant blue till 100% */}
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
              )}
              {data.initNode === `${DATA_QUALITY_REPORT.nodeModalTitle}` && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={dataQualityReportIcon}
                    width="40"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '5px' }}
                  />
                  {/* <p style={{ color: '#aaa' }}>{data.initNode}</p> */}
                </div>
              )}
              {data.initNode === 'PdfDataExtractor' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={pdfDataExtractorIcon}
                    width="50"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '0px' }}
                  />
                </div>
              )}
              {data.initNode === 'AutomaticRuleGenerator' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={ruleGeneratorIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                </div>
              )}
              {data.initNode === 'Rules Selector' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={rulesSelectorIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                </div>
              )}
              {data.initNode === 'DataQualityIssues' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={dataQualityIssuesIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                </div>
              )}
              {data.initNode === 'DataProfiling' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={dataProfilingIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                </div>
              )}
              {data.initNode === 'DataQualityIssues2' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={dataQualityIssuesIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                </div>
              )}
              {data.initNode === 'VisualInsights' && (
                <div style={{ textAlign: 'center' }}>
                  <img src={visualInsightsIcon} width="50" alt="Nagarro" />
                </div>
              )}
              <div style={{ textAlign: "center"}}>
                {nodeIconMap[data.initNode] || null}
              </div>
              {data.initNode === 'CopyDoc' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={copyDocIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                </div>
              )}
              {data.initNode === 'ReadPublishedData' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={readPublishedDataIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                </div>
              )}
              {data.initNode === 'ReadStreaming' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={readDelimitedIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                </div>
              )}
              {data.initNode === 'ReadDelimited' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={readDelimitedIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                </div>
              )}
              {data.initNode === 'ReadOracle' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={readOracleIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                </div>
              )}
              {data.initNode === 'ReadPostgres' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={readPostgresIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                </div>
              )}
              {data.initNode === FETCH_SCHEMA.nodeModalTitle && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={fetchSchemaIcon}
                    width="40"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '5px' }}
                  />
                </div>
              )}
              {data.initNode === 'ReadDB2' && (
                <div style={{ textAlign: 'center' }}>
                  <img src={readDB2Icon} width="50" alt="Nagarro" style={{ filter: 'contrast(200%)', margin: '0' }} />
                </div>
              )}
              {data.initNode === 'ReadAuroraDB' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={readAuroraDBIcon}
                    width="40"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '5px', borderRadius: '10px' }}
                  />
                </div>
              )}
              {data.initNode === 'ReadCosmos' && (
                <div style={{ textAlign: 'center' }}>
                  <img src={cosmosIcon} width="30" alt="Nagarro" style={{ filter: 'contrast(200%)', margin: '10px' }} />
                </div>
              )}
              {data.initNode === 'ReadApi' && (
                <div style={{ textAlign: 'center' }}>
                  <img src={ApiIcon} width="30" alt="Nagarro" style={{ filter: 'contrast(200%)', margin: '10px' }} />
                </div>
              )}
              {data.initNode === 'ReadMySql' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={readSqlIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                </div>
              )}
              {data.initNode === 'ReadSnowflake' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={snowflakeReadIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                </div>
              )}
              {data.initNode === 'Read Real-Time' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={readRealTimeIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                </div>
              )}
              {data.initNode === 'Write' && (
                <div style={{ textAlign: 'center' }}>
                  <img src={writeIcon} width="30" alt="Nagarro" style={{ filter: 'contrast(200%)', margin: '10px' }} />
                </div>
              )}
              {data.initNode === 'WriteAzure' && (
                <div style={{ textAlign: 'center', position: 'relative' }}>
                  <img src={writeIcon} width="30" alt="Nagarro" style={{ filter: 'contrast(200%)', margin: '10px' }} />
                  <span
                    style={{
                      position: 'absolute',
                      top: '84%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      color: '#bbb',
                      fontSize: '12px',
                      fontWeight: 'bold',
                    }}
                  >
                    azure
                  </span>
                </div>
              )}
              {data.initNode === 'WriteCsvAWS' && (
                <div style={{ textAlign: 'center', position: 'relative' }}>
                  <img src={writeIcon} width="30" alt="Nagarro" style={{ filter: 'contrast(200%)', margin: '10px' }} />
                  <span
                    style={{
                      position: 'absolute',
                      top: '86%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      color: '#bbb',
                      fontSize: '12px',
                      fontWeight: 'bold',
                    }}
                  >
                    aws
                  </span>
                </div>
              )}
              {data.initNode === 'WritePostgres' && (
                <div style={{ textAlign: 'center', position: 'relative' }}>
                  <img
                    src={readPostgresIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                  <span
                    style={{
                      position: 'absolute',
                      top: '84%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      color: '#bbb',
                      fontSize: '12px',
                      fontWeight: 'bold',
                    }}
                  >
                    write
                  </span>
                </div>
              )}
              {data.initNode === 'WriteSqlServer' && (
                <div style={{ textAlign: 'center', position: 'relative' }}>
                  <img src={mySQLServerIcon} width="50" alt="Nagarro" style={{ margin: '5px 0' }} />
                  <span
                    style={{
                      position: 'absolute',
                      top: '92%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      color: '#bbb',
                      fontSize: '12px',
                      fontWeight: 'bold',
                    }}
                  >
                    write
                  </span>
                </div>
              )}
              {data.initNode === 'WriteOracleDB' && (
                <div style={{ textAlign: 'center', position: 'relative' }}>
                  <img
                    src={readOracleIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                  <span
                    style={{
                      position: 'absolute',
                      top: '84%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      color: '#bbb',
                      fontSize: '12px',
                      fontWeight: 'bold',
                    }}
                  >
                    write
                  </span>
                </div>
              )}
              {data.initNode === 'WriteSnowflake' && (
                <div style={{ textAlign: 'center', position: 'relative' }}>
                  <img
                    src={snowFlakeIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                  <span
                    style={{
                      position: 'absolute',
                      top: '84%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      color: '#bbb',
                      fontSize: '12px',
                      fontWeight: 'bold',
                    }}
                  >
                    write
                  </span>
                </div>
              )}
              {data.initNode === 'WriteSFTP' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={writeSFTPIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                </div>
              )}{' '}
              {data.initNode === 'SnowFlake' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={snowFlakeIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                </div>
              )}
              {data.initNode === 'OpenSearch' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={openSearchIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                </div>
              )}
              {data.initNode === 'Postgres' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={DatabaseIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                </div>
              )}
              {data.initNode === 'C360' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={analyticIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                  {/* <p style={{ color: '#aaa' }}>{data.initNode}</p> */}
                </div>
              )}
              {data.initNode === 'Execute SQL' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={executeSqlIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                  {/* <p style={{ color: '#aaa' }}>{data.initNode}</p> */}
                </div>
              )}
              {data.initNode === LLM_MAPPER.nodeModalTitle && (
                <div style={{ textAlign: 'center' }}>
                  <img src={llmMapperIcon} width="50" alt="Nagarro" style={{ filter: 'contrast(200%)', margin: '0' }} />
                  {/* <p style={{ color: '#aaa' }}>{data.initNode}</p> */}
                </div>
              )}
              {data.initNode === PE_INSIGHTS_MAPPER.nodeModalTitle && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={peInsightsMapperIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                </div>
              )}
              {data.initNode === PE_DATA_REPORT.nodeModalTitle && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={pEDataReportIcon}
                    width="50"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '0px' }}
                  />
                </div>
              )}
              {data.initNode === 'KPI' && (
                <div style={{ textAlign: 'center' }}>
                  <img src={kpiIcon} width="30" alt="Nagarro" style={{ filter: 'contrast(200%)', margin: '10px' }} />
                </div>
              )}
              {data.initNode === 'Join' && (
                <div style={{ textAlign: 'center' }}>
                  <img src={joinIcon} width="30" alt="Nagarro" style={{ filter: 'contrast(200%)', margin: '10px' }} />
                  {/* <p style={{ color: '#aaa' }}>{data.initNode}</p> */}
                </div>
              )}
              {data.initNode === 'Sort' && (
                <div style={{ textAlign: 'center' }}>
                  <img src={sortIcon} width="30" alt="Nagarro" style={{ filter: 'contrast(200%)', margin: '10px' }} />
                  {/* <p style={{ color: '#aaa' }}>{data.initNode}</p> */}
                </div>
              )}
              {data.initNode === 'Filter' && (
                <div style={{ textAlign: 'center' }}>
                  <img src={filterIcon} width="30" alt="Nagarro" style={{ filter: 'contrast(200%)', margin: '10px' }} />
                  {/* <p style={{ color: '#aaa' }}>{data.initNode}</p> */}
                </div>
              )}
              {data.initNode === 'Union' && (
                <div style={{ textAlign: 'center' }}>
                  <img src={unionIcon} width="30" alt="Nagarro" style={{ filter: 'contrast(200%)', margin: '10px' }} />
                  {/* <p style={{ color: '#aaa' }}>{data.initNode}</p> */}
                </div>
              )}
              {data.initNode === 'FlatUnion' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={flatUnionIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                  {/* <p style={{ color: '#aaa' }}>{data.initNode}</p> */}
                </div>
              )}
              {data.initNode === 'Email' && (
                <div style={{ textAlign: 'center' }}>
                  <img src={emailIcon} width="30" alt="Nagarro" style={{ filter: 'contrast(200%)', margin: '10px' }} />
                </div>
              )}
              {data.initNode === 'Data Cleansing' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={cleansingIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                  {/* <p style={{ color: '#aaa' }}>{data.initNode}</p> */}
                </div>
              )}
              {data.initNode === 'Aggregation' && (
                <div style={{ textAlign: 'center' }}>
                  <img src={selectIcon} width="30" alt="Nagarro" style={{ filter: 'contrast(200%)', margin: '10px' }} />
                  {/* <p style={{ color: '#aaa' }}>{data.initNode}</p> */}
                </div>
              )}
              {data.initNode === 'StatisticalAggregation' && (
                <div style={{ textAlign: 'center' }}>
                  <img src={selectIcon} width="30" alt="Nagarro" style={{ filter: 'contrast(200%)', margin: '10px' }} />
                </div>
              )}
              {data.initNode === 'Source' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={workflowIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                  {/* <p style={{ color: '#aaa' }}>{data.initNode}</p> */}
                </div>
              )}
              {data.initNode === 'Dedupe' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={clusterIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                </div>
              )}
              {data.initNode === 'Segment' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={segmentationIcon}
                    width="35"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '7px' }}
                  />
                </div>
              )}
              {data.initNode === 'Plot' && (
                <div style={{ textAlign: 'center' }}>
                  <img src={plotIcon} width="30" alt="Nagarro" style={{ filter: 'contrast(200%)', margin: '10px' }} />
                </div>
              )}
              {/* data.initNode !== 'C360' &&
                data.initNode !== 'Write' &&
                data.initNode !== 'SnowFlake' &&
                data.initNode !== 'OpenSearch' &&
                data.initNode !== 'Ingestion Write' &&
                data.initNode !== 'Postgres' && ( */}
              {data.initNode !== 'CopyDoc' && (
                <Handle
                  type="source"
                  position="right"
                  id="a"
                  style={{
                    padding: '7px',
                    backgroundColor: '#aaa',
                  }}
                  isConnectable={isConnectable}
                />
              )}
              {data.initNode === 'Udf' && (
                <div style={{ textAlign: 'center' }}>
                  <img src={udfIcon} width="30" alt="Nagarro" style={{ filter: 'contrast(200%)', margin: '10px' }} />
                  {/* <p style={{ color: '#aaa' }}>{data.initNode}</p> */}
                </div>
              )}
              {data.initNode === 'Coalesce' && (
                <div style={{ textAlign: 'center' }}>
                  <img src={coalesce} width="30" alt="Nagarro" style={{ filter: 'contrast(200%)', margin: '10px' }} />
                  {/* <p style={{ color: '#aaa' }}>{data.initNode}</p> */}
                </div>
              )}
              {data.initNode === 'OneHot Encoder' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={oneHotEncoderIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                </div>
              )}
              {data.initNode === 'Label Encoder' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={labelEncoderIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                </div>
              )}
              {data.initNode === 'Drop' && (
                <div style={{ textAlign: 'center' }}>
                  <img src={dropIcon} width="30" alt="Nagarro" style={{ filter: 'contrast(200%)', margin: '10px' }} />
                </div>
              )}
              {data.initNode === 'Outlier' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={outlierIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                </div>
              )}
              {data.initNode === 'Imbalanced Data Sampling' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={imbalancedDataIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                </div>
              )}
              {data.initNode === 'Imbalanced Data' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={imbalancedDataIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                </div>
              )}
              {data.initNode === 'Datatype Conversion' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={datatypeIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                </div>
              )}
              {data.initNode === 'Date Time Feature' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={datetimeIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                </div>
              )}
              {data.initNode === 'Handle Null' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={handleNullIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                </div>
              )}
              {data.initNode === 'Ingestion Write' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={ingestionWrite}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                </div>
              )}
              {data.initNode === 'Training' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={trainingIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                </div>
              )}
              {data.initNode === 'Prediction' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={predictionIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                </div>
              )}
              {data.initNode === 'Scaler' && (
                <div style={{ textAlign: 'center' }}>
                  <img src={scalerIcon} width="30" alt="Nagarro" style={{ filter: 'contrast(200%)', margin: '10px' }} />
                </div>
              )}
              {data.initNode === 'Resample' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={resampleIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                </div>
              )}
              {data.initNode === 'Profiling' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={profilingIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                </div>
              )}
              {data.initNode === 'Math Transformation' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={mathTransformationIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                </div>
              )}
              {data.initNode === 'DataValidation' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={dataValidationIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                </div>
              )}
              {data.initNode === 'Data Cleaning & Validation' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={ruleEngineIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                </div>
              )}
              {data.initNode === 'Fuzzy Match' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={fuzzyLogicIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                </div>
              )}
              {data.initNode === 'Match & Merge' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={manualMergeIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                </div>
              )}
              {data.initNode === 'Customer Segmentation' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={custSegmentationIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                </div>
              )}
              {data.initNode === 'Analysis' && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={analysisIcon}
                    width="30"
                    alt="Nagarro"
                    style={{ filter: 'contrast(200%)', margin: '10px' }}
                  />
                </div>
              )}
              {data.initNode === 'FileUploader' && (
                <div style={{ textAlign: 'center' }}>
                  <img src={fileUploaderIcon} width="50" alt="Nagarro" style={{ filter: 'contrast(200%)' }} />
                </div>
              )}
              {data.initNode === 'RFM' && (
                <div style={{ textAlign: 'center' }}>
                  <img src={RfmIcon} width="30" alt="Nagarro" style={{ filter: 'contrast(200%)', margin: '10px' }} />
                </div>
              )}
            </div>
          </Tooltip>
        </div>
        {sessionStorage.getItem('isLabelVisible') === 'true' && (
          <Tooltip
            title={data.label}
            // slotProps={{
            //   popper: {
            //     sx: {
            //       [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]: {
            //         marginBottom: '70px',
            //       },
            //     },
            //   },
            // }}
            placement="right"
          >
            <label
              style={{
                display: 'inline-block',
                maxWidth: '100px', // Adjust as needed
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {data.label}
            </label>
          </Tooltip>
        )}
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Tooltip title="Delete" placement="left">
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                data.onNodesChange([{ id, type: 'remove' }]);
              }}
            >
              <DeleteIcon style={{ fontSize: '20px' }} />
            </IconButton>
          </Tooltip>
          {updated === 'completed' &&
            data.initNode !== 'Match & Merge' &&
            data.initNode !== 'DataValidation' &&
            data.initNode !== DATA_QUALITY_RULES.nodeModalTitle &&
            data.initNode !== DATA_QUALITY_RULES2.nodeModalTitle &&
            data.initNode !== DATA_QUALITY_AGENT.nodeModalTitle &&
            data.initNode !== DEDUPLICATION_AGENT.nodeModalTitle &&
            data.initNode !== LLM_DQ_RULES_2.nodeModalTitle &&
            data.initNode !== DATA_QUALITY_REPORT.nodeModalTitle &&
            data.initNode !== 'Training' &&
            data.initNode !== PE_DATA_REPORT.nodeModalTitle &&
            data.initNode !== PE_INSIGHTS_MAPPER.nodeModalTitle &&
            data.initNode !== 'Dedupe' &&
            data.initNode !== 'DataQualityIssues' && (
              <Tooltip title="Sample View" placement="right">
                <IconButton
                  onClick={(e) => {
                    e.stopPropagation();
                    fetchSampleView('fetch-result');
                    // handleOpenModal(e, data.initNode, 'sample_view');
                  }}
                >
                  <DescriptionIcon style={{ fontSize: '20px' }} />
                </IconButton>
              </Tooltip>
            )}
        </div>
      </div>
      <Modal
        open={addColumnModalOpen}
        onClose={(e) => {
          handleAddColumnModalClose(e);
        }}
        onClick={(e) => {
          e.stopPropagation();
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: '20px',
              columnGap: '10px',
            }}
          >
            <h2>
              Last Modified: <span style={{ fontSize: '16px' }}> {sampleData.ModifiedDate}</span>
            </h2>
            <Tooltip title="Sample View" placement="right">
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  fetchSampleView('run-emr');
                }}
                style={{
                  padding: '5px 10px !important',
                  border: '1px solid',
                  marginLeft: 'auto',
                }}
              >
                <RestartAltIcon fontSize="14px" />
              </IconButton>
            </Tooltip>
            <IconButton edge="end" onClick={handleFullScreenModal} aria-label="fullscreen">
              {isFullScreen ? <FiMinimize /> : <FiMaximize />}
            </IconButton>
            <IconButton edge="end" onClick={handleDownloadFile} aria-label="fullscreen">
              <BsDownload />
            </IconButton>
            <IconButton
              edge="end"
              onClick={(e) => {
                handleAddColumnModalClose(e);
              }}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </div>
          <Box sx={{ height: 500, width: '100%' }}>
            <DataGrid
              rows={sampleViewData}
              columns={sampleViewHeader}
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 15,
                  },
                },
              }}
              pageSizeOptions={[15]}
              checkboxSelection
              disableRowSelectionOnClick
            />
          </Box>
          {/* <Table dataSource={sampleData.data} columns={sampleData.headers} /> */}
        </Box>
      </Modal>
      {openModal && (
        <HtmlModal openModal={openModal} handleCloseModal={handleCloseModal} htmlData={htmlData} nodeId={id} />
      )}
      {
        <ResultModal
          openResultModal={openResultModal}
          handleCloseResultModal={handleCloseResultModal}
          fileList={fileList}
          loading={loading}
          setLoading={setLoading}
        />
      }
    </>
  );
}

export default memo(CustomNode);
